module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_vm._l((_vm.centers), function(x) {
    return _c('line', {
      attrs: {
        "x1": _vm.pointToCoordinate(x),
        "x2": _vm.pointToCoordinate(x),
        "y1": _vm.pointToCoordinate(0),
        "y2": _vm.pointToCoordinate(_vm.size - 1),
        "stroke": "black",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.centers), function(y) {
    return _c('line', {
      attrs: {
        "y1": _vm.pointToCoordinate(y),
        "y2": _vm.pointToCoordinate(y),
        "x1": _vm.pointToCoordinate(0),
        "x2": _vm.pointToCoordinate(_vm.size - 1),
        "stroke": "black",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.guides), function(dot) {
    return _c('circle', {
      attrs: {
        "cx": _vm.pointToCoordinate(dot.x),
        "cy": _vm.pointToCoordinate(dot.y),
        "r": "3"
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f568300e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/Grid.vue
// module id = 424
// module chunks = 1